import * as axios from 'axios';
let options = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
};
let instance = axios.create(options);
instance.interceptors.response.use(
  response => {
    const { status, data } = response;
    if (status !== 200) {
      return Promise.reject(data);
    } else {
      return data;
    }
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);
export default instance;


// WEBPACK FOOTER //
// ./src/services/http-request/axios.js